import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Anatomy({ onPointClick }) {
  const { nodes, materials } = useGLTF('/anatomy.gltf')
  
  return (
    <group dispose={null}>
      <group position={[0, -3, -0.01]} rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.05}>
          {Object.keys(nodes).map((key, index) => (
            <mesh 
              key={index}
              geometry={nodes[key].geometry} 
              material={materials.material0} 
              onClick={(e) => {
                e.stopPropagation(); // stop event from propagating to canvas
                onPointClick(e.point); // get 3D coordinate
              }}
            />
          ))}
        </group>
      </group>
    </group>
  )
}

